import { Injectable } from '@angular/core';
import { forkJoin, Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { PreinvoiceLookups } from './preinvoice-form.models';
import { UserCompanyService } from '../../../../modules/user/usercompany/usercompany.service';
import { MasterService } from '../../../master/services/master.service';

@Injectable({ providedIn: 'root' })
export class PreinvoiceLookupsFacade {
  constructor(
    private masterService: MasterService,
    private userCompanyService: UserCompanyService
  ) { }

  loadAll$(): Observable<PreinvoiceLookups> {
    return forkJoin({
      payMethods: this.masterService.getPayMethodTickets(),
      taxes: this.masterService.getTaxes(),
      concepts: this.masterService.getConcepts(),
      unitMeasurable: this.masterService.getUnitMeasurables(),
      accountingModels: this.masterService.getAccountingModels(),
      contacts: this.masterService.getContacts(),
      userCompany: from(this.userCompanyService.loadData()), // típico Promise
    }).pipe(
      map((x: any) => ({
        contacts: x.contacts || [],
        payMethods: x.payMethods || [],
        bankAccounts: [],
        cashRegisters: [],
        partners: [],
        taxes: x.taxes || [],
        concepts: x.concepts || [],
        projects: [],
        unitMeasurable: x.unitMeasurable || [],
        accountingModels: x.accountingModels || [],
        userCompany: x.userCompany || null,
        centers: []
      }))
    );
  }

  loadBankAccounts$(): Observable<any[]> {
    return this.masterService.getBankAccounts();
  }

  loadCashRegisters$(): Observable<any[]> {
    return this.masterService.getCashRegisters();
  }

  loadPartners$(): Observable<any[]> {
    return this.masterService.getParnerts();
  }

  loadProjects$(): Observable<any[]> {
    return this.masterService.getProjects();
  }

  loadContacts$(): Observable<any[]> {
    return this.masterService.getContacts();
  }

  loadCenters$(contactUid?: string): Observable<any[]> {
    return this.masterService.getCenters(contactUid);
  }
}
